import en from "./en";
import yue from "./yue";
import zh from "./zh";

export const messagesByLocale = { zh, yue, en };
